/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_Inline_CodeInputs */

const en_common_editor_inline_code = /** @type {(inputs: Common_Editor_Inline_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inline code`)
};

const zh_common_editor_inline_code = /** @type {(inputs: Common_Editor_Inline_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行内代码`)
};

/**
* | output |
* | --- |
* | "Inline code" |
*
* @param {Common_Editor_Inline_CodeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_inline_code = /** @type {((inputs?: Common_Editor_Inline_CodeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_Inline_CodeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_inline_code(inputs)
	return zh_common_editor_inline_code(inputs)
});
export { common_editor_inline_code as "common.editor.inline_code" }